module.exports = __webpack_public_path__ + "static/media/faqBalance-es-ko.796b1609.vtt";